import type { ItemData } from '../data-list-managers';
import type { Node } from './create-node';
import { createNode } from './create-node';

type Parent = null | { id: string };

export const flatByID = <TKey extends string, T extends ItemData<TKey> & { Items?: T[] }>(
  arr: T[],
  cb: { (node: Node<T>): void },
  key: TKey,
  parent?: Parent,
) => {
  if (!arr) return;

  const len = arr.length;
  let i = 0;
  let prev: null | Node<T> = null;

  while (i < len) {
    const item = arr[i];

    // delete data.Items
    const node: Node<T> = createNode({
      id: item[key] as string,
      data: item,
      index: i,
      parent: parent?.id,
      prev: prev?.id,
      next: arr[i + 1]?.[key] as string,
    });
    prev = node;

    cb(node);

    if (item.Items?.length) {
      flatByID(item.Items, cb, key, node);
    }

    i++;
  }
};
